module.exports = __webpack_public_path__ + "static/media/btn-googleplay.b8490f0b.png";